export const baseUrl = process.env.REACT_APP_RECEIPT_URL;
